var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3C22.1172 3 23.25 4.13281 23.25 5.5V18C23.25 19.4062 22.1172 20.5 20.75 20.5H3.25C1.84375 20.5 0.75 19.4062 0.75 18V5.5C0.75 4.13281 1.84375 3 3.25 3H8.875V1.75C8.875 1.08594 9.42188 0.5 10.125 0.5H13.875C14.5391 0.5 15.125 1.08594 15.125 1.75V3H20.75ZM10.75 2.375V4.875H13.25V2.375H10.75ZM21.375 18V5.5C21.375 5.1875 21.0625 4.875 20.75 4.875H15.125V6.75H8.875V4.875H3.25C2.89844 4.875 2.625 5.1875 2.625 5.5V18C2.625 18.3516 2.89844 18.625 3.25 18.625H7.625C7.625 18.5859 7.625 18.5469 7.625 18.5078V17.7656C7.625 16.5156 8.79688 15.5 10.2422 15.5C10.6719 15.5 10.9453 15.8125 12 15.8125C13.0156 15.8125 13.3281 15.5 13.7188 15.5C15.1641 15.5 16.375 16.5156 16.375 17.7656V18.5078C16.375 18.5469 16.3359 18.5859 16.3359 18.625H20.75C21.0625 18.625 21.375 18.3516 21.375 18ZM12 9.25C13.3672 9.25 14.5 10.3828 14.5 11.75C14.5 13.1562 13.3672 14.25 12 14.25C10.5938 14.25 9.5 13.1562 9.5 11.75C9.5 10.3828 10.5938 9.25 12 9.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.c7d5ba62a1d2ee05f5fa4004161ec1fc.svg";
export { ForwardRef as ReactComponent };